import React from 'react';
interface CountryListProps{
  visited:any[],
  removeCountry?:Function,
}


const CountryList:React.FunctionComponent<CountryListProps> = ({visited,removeCountry}:CountryListProps) => {
  return (
    <>
      <h2>Countries Visited {(visited || []).length}</h2>
      {
        !!visited?.length && (
          <>
            {removeCountry && <h4>Click to Delete Country</h4>}
            <ul>
              {visited?.map((country,i) => (
                <li
                  key={i}
                  onClick={!!removeCountry ? _=>removeCountry(country.key): undefined}
                  >
                  {country.value} - {country.displayDate}
                </li>
              ))}
            </ul>
          </>
        )
      }
    </>
  )
}
export default CountryList
